import * as React from 'react';
import { Box, HeadingText } from '@leagueplatform/genesis-core';
import {
  BackButtonArrow,
  PageContainer,
} from '@leagueplatform/web-common-components';

export type HeroBannerProps = {
  heading?: string;
  hideBackButton?: boolean;
  onBackButtonClick?: (event: React.MouseEvent) => void;
  className?: string;
  'data-testid'?: string;
};

export const HeroBanner = ({
  heading,
  hideBackButton,
  onBackButtonClick,
  className,
  'data-testid': dataTestId,
}: HeroBannerProps) => (
  <Box
    css={{
      position: 'relative',
      '&:before': {
        backgroundColor: '$surfaceScreenHeaderBackground',
        content: '""',
        zIndex: '-1',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 'calc(-50vw + 50%)',
        right: 'calc(-50vw + 50%)',
      },
    }}
    className={className}
    data-testid={dataTestId}
  >
    <PageContainer>
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: '$one',
          paddingBlock: '$two',
        }}
      >
        {!hideBackButton && (
          <BackButtonArrow onClick={onBackButtonClick} id="go-back" />
        )}
        <HeadingText level="1" size="xl">
          {heading}
        </HeadingText>
      </Box>
    </PageContainer>
  </Box>
);
